<micro-select-combo #sel
              placeholder="SMS Type"
              routerBase="sms/smsTypes"
              [mode]="mode"
              [(id)]="smsTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [jump]="jump"
>
</micro-select-combo>
